import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/views/home.vue'

import { useAuthStore } from "@/stores/auth.js";

function isAdmin(to) {
  return useAuthStore().isAdmin ? true : { name: 'home' }
}

const router = createRouter({
  history: createWebHistory( import.meta.env.BASE_URL ),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( '@/views/login.vue' )
    },
    {
      path: '/create-account',
      name: 'createAccount',
      component: () => import( '@/views/account/createAccount.vue' )
    },
    {
      path: '/modify-account',
      name: 'modifyAccount',
      component: () => import( '@/views/account/modifyAccount.vue' )
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      component: () => import( '@/views/account/resetPassword.vue' )
    },
    {
      path: '/change-email',
      name: 'changeEmail',
      component: () => import( '@/views/account/changeEmail.vue' )
    },
    {
      path: '/request-password-reset',
      name: 'requestPasswordReset',
      component: () => import( '@/views/account/requestPasswordReset.vue' )
    },
    {
      path: '/prices',
      name: 'prices',
      component: () => import( '@/views/prices.vue' )
    },
    {
      path: '/purchase-successful',
      name: 'purchaseSuccessful',
      component: () => import( '@/views/purchaseSuccessful.vue' )
    },
    {
      path: '/purchase-cancelled',
      name: 'purchaseCancelled',
      component: () => import( '@/views/purchaseCancelled.vue' )
    },
    {
      path: '/view-games',
      name: 'viewGames',
      component: () => import( '@/views/games/viewGames.vue' )
    },
    {
      path: '/record-game',
      name: 'recordGame',
      component: () => import( '@/views/games/recordGame.vue' )
    },
    {
      path: '/create-game',
      name: 'createGame',
      component: () => import( '@/views/games/createGame.vue' )
    },
    {
      path: '/admin',
      beforeEnter: [isAdmin],
      children: [
        {
          path: '',
          name: 'adminDashboard',
          component: () => import( '@/views/admin/dashboard.vue' )
        }
      ]
    }
  ]
})

export default router
